export function formatPrice(price) {
  if (price === undefined) {
    return undefined
  }
  const priceWithComma = price?.toFixed(2)?.toString()?.replace(/\./, ',')
  const priceWithCommaAndCurrency = `${priceWithComma} €`
  return priceWithCommaAndCurrency
}
